import {
  SET_LESSON,
  // SET_VIDEO_START,
  FINISH_LESSON,
  SET_HISTORY_LESSON,
  SET_MESSAGES_TO_HISTORY
} from '@/store/mutations.js';
import apiRequest from '@/js/helpers/apiRequest.js';
import notify from '@/js/helpers/notify.js';

export default {
  state: {
    lesson: {},
    // videoStart: false,
    history: []
  },

  mutations: {
    [SET_LESSON]: (state, { lesson } = {}) => {
      state.lesson = lesson;
    },

    // [SET_VIDEO_START]: (state) => {
    //   state.videoStart = true;
    // },

    [FINISH_LESSON]: (state) => {
      state.lesson = {};
    },

    [SET_HISTORY_LESSON]: (state, { history }) => {
      state.history = history;
    },

    [SET_MESSAGES_TO_HISTORY]: (state, { messages, lessonId }) => {
      state.history.find(
        (lesson) => lesson.id === Number(lessonId)
      ).messages = messages;
    }
  },

  actions: {
    // eslint-disable-next-line no-unused-vars
    async finishLesson({ commit }, { id }) {
      const res = await apiRequest(`lesson/end/${id}`, 'POST', null, true);

      if (res.error) {
        throw { customeError: res.error };
      }
    },

    async getLessonHistory({ commit }) {
      try {
        const res = await apiRequest('history/lessons', 'GET', null, true);

        if (res.error) {
          throw { customeError: res.error };
        }

        const history = res.success
          .map(({ id, start, level, end, name, teacher }) => ({
            id,
            start,
            end,
            name,
            level,
            teacher: {
              id: teacher.id,
              avatar: teacher.avatar,
              name: teacher.name,
              lastName: teacher.last_name
            },
            messages: []
          }))
          .sort((a, b) => new Date(b.start) - new Date(a.start));

        commit(SET_HISTORY_LESSON, { history });
      } catch (error) {
        if (error.customeError) {
          notify({ text: error.customeError });
        } else {
          console.error(error);
          notify({ text: this.$t(`notify.something_went_wrong`) });
        }
      }
    },

    getHistoryMessagesById: async ({ rootState, commit }, { id }) => {
      const res = await apiRequest(`history/lessons/${id}`, 'GET', null, true);

      if (res.error) {
        throw { customeError: res.error };
      }

      const userId = rootState.user.info.id;

      const messages = res.success.messages.map(
        ({
          id,
          created_at,
          mark,
          quote,
          quote_date,
          user_id,
          text,
          attachments
        }) => ({
          id,
          type: user_id === userId ? 'sent' : 'received',
          date: created_at,
          userId: user_id,
          text,
          mark,
          quote,
          quoteDate: quote_date,
          attachment:
            attachments && attachments.length
              ? {
                  src: attachments[0].src,
                  name: attachments[0].name,
                  type: attachments[0].type,
                  size: attachments[0].size
                }
              : null
        })
      );

      commit(SET_MESSAGES_TO_HISTORY, { messages, lessonId: id });
    }
  }
};
